export default function CuisineSection() {
  const dishes = [
    {
      name: '但馬牛すき焼き',
      price: '12,000円〜',
      image: 'https://static.readdy.ai/image/cc91b7789a14262b14655463cd9fff45/fec338c32c1003b45bcd380558ef7369.jpeg',
    },
    {
      name: '鴨鍋',
      price: '9,000円〜',
      image: 'https://static.readdy.ai/image/cc91b7789a14262b14655463cd9fff45/34112221b34bef8a344bc4947b56637a.jpeg',
    },
    {
      name: '猪豚鍋',
      price: '９,０00円〜',
      image: 'https://static.readdy.ai/image/cc91b7789a14262b14655463cd9fff45/7e8ec290c1b60911af8d44aee4f9e578.jpeg',
    },
    {
      name: 'かにちり鍋',
      price: '14,000円〜',
      image: 'https://static.readdy.ai/image/cc91b7789a14262b14655463cd9fff45/82b8d6faaf134db087cabe0c1070514b.jpeg',
    },
  ];

  return (
    <section id="cuisine" className="py-20 md:py-32 px-6 bg-white relative overflow-hidden">
      {/* Washi Texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="max-w-7xl mx-auto relative">
        {/* Header */}
        <div className="mb-16">
          <div className="grid md:grid-cols-3 gap-8 items-end">
            <div className="md:col-span-1">
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest-800 leading-tight">
                こだわりの
                <br />
                高原料理
              </h2>
            </div>
            <div className="md:col-span-2">
              <p className="text-gray-700 leading-relaxed text-base mb-4">
                食事は食堂で提供いたします（個室食は承っておりません）。朝のコーヒーは自由にお飲みいただけます。
              </p>
              <p className="text-gray-700 leading-relaxed text-base">
                お子様のお食事は大人と同じ内容を量調整してご提供いたします。幼児向けの特別食はご用意しておりませんので、予めご了承ください。
              </p>
            </div>
          </div>
        </div>

        {/* Dishes Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {dishes.map((dish, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative w-full h-[320px] overflow-hidden">
                <img
                  src={dish.image}
                  alt={dish.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-900/60 to-transparent"></div>
              </div>
              <div className="p-6 bg-forest-800">
                <h3 className="font-serif text-xl font-semibold text-white mb-2">
                  {dish.name}
                </h3>
                <p className="text-gold-400 text-lg font-medium mb-4">{dish.price}</p>
                <div className="flex items-center text-white text-sm group-hover:text-gold-400 transition-colors">
                  <span className="whitespace-nowrap">詳細を見る</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}